import { GeocodeResultDc, GeocodeParams } from "@evergis/api";
import { createResource } from "@evergis/react-fetching";

import { api as evergisApi } from "../evergis/api";

export const GEOCODE_PROVIDER = "geocode2gis";
export const GEOCODE_PROVIDER_CADASTR = "geocodeNspd";
export const GEOCODE_PROVIDER_ORGANIZATIONS = "places2gis";

export const geocodeAddress = createResource(
  ({ address, sr, bboxPoints, providerName = GEOCODE_PROVIDER }: GeocodeParams) =>
    async api => {
      let results: GeocodeResultDc[] = [];

      try {
        results = await api.geocode.geocode({
          address,
          sr,
          bboxPoints,
          providerName,
        });
      } catch (e) {
        // TODO send notification
      }

      return {
        data: results,
      };
    },
  {
    injected: evergisApi,
  },
);
